<div class="main-content">
  <div class="header ion-padding horizontal-padding "  role="heading" aria-level="2">{{ "DISTANCE" | translate }}</div>
  <div class="content horizontal-padding">
    <div class="miles-lebel">
      {{ miles[distance].value }} {{ (miles[distance].value === 1 ? "MILE" : "MILES") | translate }}
    </div>
    <div class="range-wrapper">
      <div class="range-label">
        <div class="ion-text-center" *ngFor="let mile of miles">
          {{ mile.label }} {{ (mile.value === 1 ? "MILE" : "MILES") | translate }}
        </div>
      </div>
      <ion-range
        #distanceRange
        data-cy="rangeInput"
        [(ngModel)]="distance"
        color="eprintprimary"
        ticks="true"
        snaps="true"
        min="0"
        max="5"
        [attr.aria-label]="'DISTANCE' | translate"
        (ionChange)="updateRangeAccessibility()"
      ></ion-range>
    </div>

    <ion-button
      data-cy="distanceApplyBtn"
      [disabled]="this.miles[distance]?.value === distanceInMiles"
      color="eprintprimary"
      size="small"
      shape="block"
      (click)="apply()"
    >
      {{ "APPLY" | translate }}
    </ion-button>
  </div>
</div>
